import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

import MapComponent from './map-component';
import MapScrubComponent from './map-scrub-component';


class HeroMapComponentItem {
    constructor(el, index) {
        this.render(el, index);
    }

    openMap () {
        if(this.scrub){
            this.scrub.hide();
        }
        TweenMax.to( this.heading, 1, { x: 0, opacity: 0, ease: Cubic.easeInOut, delay: 0.6 } );
        TweenMax.to(this.descript, 1, { x: 0, opacity: 0, ease: Cubic.easeInOut, delay: 0.65 });
        TweenMax.to(this.buttonExplore, 1, { x: 0, opacity: 0, ease: Cubic.easeInOut, delay: 0.7 });
        TweenMax.to(this.overlay, 1, { opacity: 0, ease: Cubic.easeInOut, delay: 1.1, onComplete: this.onMap_OPEN.bind(this) });

        this.buttonExplore.css('pointer-events', 'none');
    }

    onMap_OPEN () {
        this.overlay.css('pointer-events', 'none');
        this.content.css('pointer-events', 'none');

        if(this.map){
            this.map.show();
        }

        TweenMax.set( this.nav, { opacity: 1 } );

        TweenMax.fromTo(this.title, 0.6, { y: -20, opacity: 0 }, { y: 0, opacity: 1, ease: Cubic.easeOut, delay: 1.5 });
        TweenMax.fromTo( this.close, 0.6, { x: -20, opacity: 0 }, { x: 0, opacity: 1, ease: Cubic.easeOut, delay: 1.6 } );

        this.close.css('pointer-events', 'auto');
    }

    closeMap () {
        this.close.css('pointer-events', 'none');
        this.overlay.css('pointer-events', 'auto');
        this.content.css('pointer-events', 'auto');

        TweenMax.to(this.title, 0.6, { y: -20, opacity: 0, ease: Cubic.easeInOut, delay: 0 });
        TweenMax.to( this.close, 0.6, { x: -20, opacity: 0, ease: Cubic.easeInOut, delay: 0.1 } );

        if(this.map){
            this.map.hide();
        }

        TweenMax.to( this, 2, { onComplete: this.onMapClose.bind(this) } );
    }

    onMapClose () {
        TweenMax.set( this.nav, { opacity: 0 } );

        if(this.scrub){
            this.scrub.show();
        }

        TweenMax.to( this.overlay, 1, { opacity: 1, ease: Cubic.easeInOut, delay: 0.0 } );
        TweenMax.fromTo( this.heading, 1, { x: 100, opacity: 0 }, { x: 0, opacity: 1, ease: Cubic.easeInOut, delay: 0.1 } );
        TweenMax.fromTo(this.descript, 1, { x: 100, opacity: 0 }, { x: 0, opacity: 1, ease: Cubic.easeInOut, delay: 0.15 });
        TweenMax.fromTo(this.buttonExplore, 1, { x: 100, opacity: 0 }, { x: 0, opacity: 1, ease: Cubic.easeInOut, delay: 0.2, onComplete: this.reset.bind(this) });
        
    }

    scrub_COMPLETE ( e ) {
        this.openMap();
    }

    buttonExplore_CLICK(e) {
        e.preventDefault();
        this.openMap();
    }

    reset() {
        this.buttonExplore.css('pointer-events', 'auto');
    }

    render (el, index) {
        this.element = $(el);
        
        this.scrub = this.element.find('*[data-component="c-map-scrub-component"]');
        
        if( this.scrub.length ){
            this.scrub = new MapScrubComponent(this.scrub.eq(0));
            $(this.scrub).on( MapScrubComponent.EVENT.MAP_SCRUB_COMPLETE, this.scrub_COMPLETE.bind(this) );
        } else {
            this.scrub = null;
        }

        this.map = this.element.find('*[data-component="c-map-component"]');
        
        if( this.map.length ){
            if(this.map.eq(0).attr('data-map-component-type') == "hero"){
                this.map = new MapComponent(this.map.eq(0), -1);
            }
        } else {
            this.map = null;
        }

        this.overlay = this.element.find('*[data-component="c-hero-map-overlay"]');
        this.content = this.element.find('*[data-component="c-hero-map-content"]');
        this.heading = this.element.find('*[data-component="c-hero-map-heading"]');
        this.descript = this.element.find('*[data-component="c-hero-map-descript"]');
        this.options = this.element.find('*[data-component="c-hero-map-options"]');

        this.nav = this.element.find('*[data-component="c-hero-map-nav"]');
        this.title = this.element.find('*[data-component="c-hero-map-nav-title"]');
        this.close = this.element.find('*[data-component="c-hero-map-nav-close"]');

        this.buttonExplore = this.element.find('*[data-component="c-hero-map-button-explore"]');

        $(this.buttonExplore).on('click', this.buttonExplore_CLICK.bind(this));
        $(this.close).on('click', this.closeMap.bind(this));

    }
}

class HeroMapComponent {
    constructor(selector) {
        this.all = document.querySelectorAll(selector);
        for ( var i = 0; i < this.all.length; i++ ) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new HeroMapComponentItem(el, index);
    }
}

export default HeroMapComponent;
